/**
 * Group the disputed rows on screen into the summary shape the backend returns:
 * [{ id, name, count, games: [{ id, name, count }] }], sorted by name (869fg2gvw).
 * Names come from the full summary (rows carry no provider name); a provider
 * or game it does not know falls back to "#id". Rows without a provider are
 * skipped: the filter cannot select them.
 */
export function groupDisputes(rows, summary = []) {
    const known = new Map((summary ?? []).map((p) => [p.id, p]));
    const providers = new Map();
    for (const r of rows ?? []) {
        if (r.providerId == null) continue;
        const ref = known.get(r.providerId);
        const p = providers.get(r.providerId)
            ?? { id: r.providerId, name: ref?.name ?? `#${r.providerId}`, count: 0, games: [], byId: new Map() };
        providers.set(r.providerId, p);
        p.count += 1;
        if (r.gameNameId == null) continue;
        let g = p.byId.get(r.gameNameId);
        if (!g) {
            const name = r.gameName ?? ref?.games.find((x) => x.id === r.gameNameId)?.name ?? `#${r.gameNameId}`;
            g = { id: r.gameNameId, name, count: 0 };
            p.byId.set(r.gameNameId, g);
            p.games.push(g);
        }
        g.count += 1;
    }
    const byName = (a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' });
    return [...providers.values()]
        .map(({ byId, ...p }) => ({ ...p, games: p.games.sort(byName) }))
        .sort(byName);
}

const gamesWord = (n) => {
    const d = n % 10, h = n % 100;
    if (d === 1 && h !== 11) return 'игра';
    if (d >= 2 && d <= 4 && (h < 12 || h > 14)) return 'игры';
    return 'игр';
};

/** "3 игры · 12" — the hint next to a provider in the filter. */
export function providerLabel(p) {
    const n = p.games.length;
    return `${n} ${gamesWord(n)} · ${p.count}`;
}
